import { render } from "./CircleCheckIcon.vue?vue&type=template&id=08ae5a20"
import script from "./CircleCheckIcon.vue?vue&type=script&lang=js"
export * from "./CircleCheckIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__